'use client'

import React, { useMemo } from 'react'

import { useTranslations } from 'next-intl'

import useFormatDate from '@/src/hooks/date/useFormatDate'
import { RecentSearchListItem, useRecentSearch } from '@/src/hooks/srp/recentSearch'
import { isServer } from '@/src/utils/browser'
import { RecentSearchList } from './recentSearchList'

interface RecentSearchListWrapperProps {
    serverRecentSearches: RecentSearchListItem[]
}

const RecentSearchListWrapper: React.FC<RecentSearchListWrapperProps> = ({ serverRecentSearches }) => {
    const { getRecentSearchList } = useRecentSearch()
    const t = useTranslations('homePage.headings')
    const tCommon = useTranslations('common')
    const { formatDate } = useFormatDate()

    const recentSearches = useMemo(
        () => (isServer() ? serverRecentSearches : getRecentSearchList()),
        [serverRecentSearches]
    )

    if (!recentSearches || recentSearches.length === 0) {
        return null
    }

    return <RecentSearchList formatDate={formatDate} flightsSearchList={recentSearches} t={t} tCommon={tCommon} />
}

export { RecentSearchListWrapper }
export default RecentSearchListWrapper
